/**
 * List behaviour, in one place so two screens cannot disagree about it.
 */

/**
 * Rows per page in the clinic list.
 *
 * Paging is CLIENT-SIDE: the BFF answers `clinics` with the whole estate in one
 * call (it joins every clinic to a batched entitlement snapshot), so narrowing,
 * sorting and paging cost no round trip. 50 is chosen against the two failure
 * modes — a page an operator has to scroll twice, and a DOM big enough to make
 * sorting feel slow. DESIGN-CONCEPT §9.1 caps unbounded rendering at ~200 rows.
 *
 * When the estate passes roughly a thousand clinics this has to move to the
 * server (`limit`/`offset`/`sort` on the query), and the filters with it. That
 * is a BFF change, not a client one; until then client paging is the honest
 * shape, because the data is already here.
 */
export const PAGE_SIZE = 50;

/** Debounce before a typed search narrows the list (DESIGN-CONCEPT §8). */
export const SEARCH_DEBOUNCE_MS = 300;

/**
 * Below this, a typed search is ignored.
 *
 * One character matches most of the estate, so it costs a full re-render and
 * narrows nothing. Zero characters is different — that is "cleared", and it
 * shows everything.
 */
export const SEARCH_MIN_CHARS = 2;

/** Events shown before «نمایش بیشتر», and how many each press adds. */
export const EVENT_PAGE_SIZE = 20;

/**
 * A term is "about to lapse" within this many days.
 *
 * It drives an amber hint, not a filter: the point is that an operator scanning
 * the list sees the ones that will need work this fortnight without having to
 * read and subtract dates.
 */
export const LAPSE_SOON_DAYS = 14;
